
import { defineComponent, ref } from "vue";
import { TokenUtils } from "@/utils/TokenUtils";
import { Helper } from "@/utils/Helper"
import { useStore } from 'vuex';

export default defineComponent({
  name: "accountTokensComponent",
  setup(){
    const store = useStore();
    const userObj = store.getters['auth/user'];
    const username = ref(userObj.username);
    const walletAddress = userObj.walletAddress;
    const displayTokens = ref([]);
    (async() => {
      let tokenUtils = new TokenUtils()
      let tokens = await tokenUtils.getWalletAddressToken(walletAddress);
      displayTokens.value = tokens;
    })()
    return {
      username,
      displayTokens,
      Helper,
    }
  }
});
